import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 3.755v16.5m-9.75-8.25h19.5m-15.375 5.25a4.875 4.875 0 0 0 4.875-4.875v-.375m6.375 5.25a4.875 4.875 0 0 1-4.875-4.875v-.375m-9 8.25h16.5a1.5 1.5 0 0 0 1.5-1.5v-13.5a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5m12.621-9.44c-1.409 1.41-4.242 1.061-4.242 1.061s-.349-2.834 1.06-4.243a2.25 2.25 0 0 1 3.182 3.182m-5.598-3.182c1.409 1.41 1.06 4.243 1.06 4.243s-2.833.348-4.242-1.06a2.25 2.25 0 0 1 3.182-3.183"
    }, null, -1)
  ])))
}
export default { render: render }